import React, { useRef, useState } from 'react';

import { Menu, MenuItem, TextField, Zoom } from '@material-ui/core';
import styled from 'styled-components';
import { StyledBox } from 'styles/common';

import { generateKey } from 'constants/helper';
import { ChevronLeftIcon, ChevronRightIcon, DotsIcon, PlusIcon2, RemoveIconV2, StyledIconV2 } from 'constants/icons';
import theme from 'constants/theme';

import { addJobFunctionLevel, deleteJobFunctionLevel, moveJobFunctionLevel } from 'services/growth/admin';

import CircularOutlineIcon from 'uiToolkit/CircularOutlineIcon';
import { Typography12 } from 'uiToolkit/Typography';

import { useSelectedJobFunctionContext } from '../../GrowthSettings';
import { OTHER_ACTIONS, RETRY_COUNT, TABLE_LAYOUT_ACTIONS } from '../GrowthTableContext';
import { StyledRoleHeaderCell } from '../GrowthTableHelperComps';

const CONTROL_OPTIONS = {
  MOVE_LEFT: 'MOVE_LEFT',
  MOVE_RIGHT: 'MOVE_RIGHT',
  ADD_LEVEL: 'ADD_LEVEL',
  REMOVE_LEVEL: 'REMOVE_LEVEL',
};

const RoleHeaderCell = ({ uuid, index, levelCount, label, onEdit, layoutReducerDispatch, isLoading }) => {
  const { selectedJobFunction } = useSelectedJobFunctionContext();
  const ref = useRef(null);

  const [localText, setLocalText] = useState(label);
  const [error, setError] = useState('');

  const [anchorEl, setAnchorEl] = useState(null);

  const [mouseOver, setMouseOver] = useState(false);

  const handleMoreOptionsMenuOpen = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleMoreOptionsMenuClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  const handleOptionSelect = (e, option) => {
    switch (option) {
      case CONTROL_OPTIONS.ADD_LEVEL: {
        const feUuid = `role-${generateKey(5)}`;

        layoutReducerDispatch({
          type: TABLE_LAYOUT_ACTIONS.ADD_ROLE,
          payload: { insertionIndex: index + 1, uuid: feUuid },
        });

        let retryCount = RETRY_COUNT;

        const makeApiCall = () =>
          addJobFunctionLevel({
            jobFunctionId: selectedJobFunction.uuid,
            insertAfterLevelId: uuid,
          })
            .then((res) => {
              layoutReducerDispatch({
                type: TABLE_LAYOUT_ACTIONS.REMOVE_ROLE_LOADING,
                payload: { feUuid, beUuid: res?.uuid, name: res?.name },
              });
            })
            .catch((err) => {
              if (retryCount !== 0) {
                retryCount--;
                makeApiCall();
              } else {
                layoutReducerDispatch({
                  type: OTHER_ACTIONS.SET_ERROR,
                  payload: {},
                });
                console.error(err);
              }
            });

        makeApiCall();
        break;
      }
      case CONTROL_OPTIONS.REMOVE_LEVEL: {
        layoutReducerDispatch({
          type: TABLE_LAYOUT_ACTIONS.DELETE_ROLE_COLUMN,
          payload: { roleUuid: uuid },
        });
        let retryCount = RETRY_COUNT;
        const makeApiCall = () =>
          deleteJobFunctionLevel({ jobFunctionId: selectedJobFunction.uuid, levelId: uuid })
            .then((res) => console.log(res))
            .catch((err) => {
              if (retryCount !== 0) {
                retryCount--;
                makeApiCall();
              } else {
                layoutReducerDispatch({
                  type: OTHER_ACTIONS.SET_ERROR,
                  payload: {},
                });
                console.error(err);
              }
            });

        makeApiCall();

        break;
      }
      case CONTROL_OPTIONS.MOVE_LEFT: {
        layoutReducerDispatch({
          type: TABLE_LAYOUT_ACTIONS.MOVE_ROLE_COLUMN,
          payload: { currentIndex: index, moveToIndex: index - 1 },
        });

        if (index - 1 >= 0) {
          let retryCount = RETRY_COUNT;
          const makeApiCall = () =>
            moveJobFunctionLevel({
              jobFunctionId: selectedJobFunction.uuid,
              levelId: uuid,
              moveDirection: 'left',
            })
              .then((res) => {})
              .catch((err) => {
                if (retryCount !== 0) {
                  retryCount--;
                  makeApiCall();
                } else {
                  layoutReducerDispatch({
                    type: OTHER_ACTIONS.SET_ERROR,
                    payload: {},
                  });
                  console.error(err);
                }
              });

          makeApiCall();
        }

        break;
      }
      case CONTROL_OPTIONS.MOVE_RIGHT: {
        layoutReducerDispatch({
          type: TABLE_LAYOUT_ACTIONS.MOVE_ROLE_COLUMN,
          payload: { currentIndex: index, moveToIndex: index + 1 },
        });

        if (index + 1 < levelCount) {
          let retryCount = RETRY_COUNT;

          const makeApiCall = () =>
            moveJobFunctionLevel({
              jobFunctionId: selectedJobFunction.uuid,
              levelId: uuid,
              moveDirection: 'right',
            })
              .then((res) => {})
              .catch((err) => {
                if (retryCount !== 0) {
                  retryCount--;
                  makeApiCall();
                } else {
                  layoutReducerDispatch({
                    type: OTHER_ACTIONS.SET_ERROR,
                    payload: {},
                  });
                  console.error(err);
                }
              });
          makeApiCall();
        }

        break;
      }
      default:
        break;
    }
    handleMoreOptionsMenuClose(e);
  };

  const handleBlur = () => {
    onEdit(localText, uuid);
    // .then(res => {
    //   // setLocalText()
    //   setError('');
    // })
    // .catch(err => {
    //   const errorMessage = err.message || 'failed to update';
    //   console.log(errorMessage);
    //   setError(errorMessage);
    // });
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      if (ref?.current) ref.current.blur();
    }
  };

  const handleInput = (event) => {
    setLocalText(event.target.value);
  };

  return (
    <StyledRoleHeaderCell onMouseEnter={() => setMouseOver(true)} onMouseLeave={() => setMouseOver(false)}>
      <StyledTextField
        isTextNewRole={localText === 'New Role'}
        inputRef={ref}
        variant="outlined"
        id="label"
        value={localText}
        onChange={handleInput}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        error={error}
        placeholder="Enter Role"
        disabled // adding disabled as BE support is not there yet
      />
      <Zoom
        // in={mouseOver && !isLoading} //disabled as BE support is not there yet
        in={false}
      >
        <StyledBox>
          <CircularOutlineIcon
            leftGutter={1}
            onClick={handleMoreOptionsMenuOpen}
            color="primary"
            icon={StyledDotsIcon}
          />
          <StyledMenu
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 16,
            }}
            getContentAnchorEl={null}
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMoreOptionsMenuClose}
          >
            <StyledMenuItem onClick={(e) => handleOptionSelect(e, 'MOVE_LEFT')}>
              <ChevronLeftIcon
                size="fixed10px"
                containerSize="fixed24px"
                circularOutline
                color={theme.palette.primary.main}
              />
              <Typography12 leftGutter={1.5} color={theme.palette.primary.main}>
                Move Left
              </Typography12>
            </StyledMenuItem>
            <StyledMenuItem onClick={(e) => handleOptionSelect(e, 'MOVE_RIGHT')}>
              <ChevronRightIcon
                size="fixed10px"
                containerSize="fixed24px"
                circularOutline
                color={theme.palette.primary.main}
              />
              <Typography12 leftGutter={1.5} color={theme.palette.primary.main}>
                Move Right
              </Typography12>
            </StyledMenuItem>
            <StyledMenuItem onClick={(e) => handleOptionSelect(e, 'ADD_LEVEL')}>
              <StyledIconV2
                size="fixed10px"
                containerSize="fixed24px"
                circularOutline
                color={theme.palette.primary.main}
              >
                <PlusIcon2 />
              </StyledIconV2>
              <Typography12 leftGutter={1.5} color={theme.palette.primary.main}>
                Add Role
              </Typography12>
            </StyledMenuItem>
            <StyledMenuItem onClick={(e) => handleOptionSelect(e, 'REMOVE_LEVEL')}>
              <RemoveIconV2
                size="fixed10px"
                containerSize="fixed24px"
                circularOutline
                color={theme.palette.primary.main}
              />
              <Typography12 leftGutter={1.5} color={theme.palette.primary.main}>
                Remove Role
              </Typography12>
            </StyledMenuItem>
          </StyledMenu>
        </StyledBox>
      </Zoom>
    </StyledRoleHeaderCell>
  );
};

const StyledDotsIcon = styled(DotsIcon)`
  width: 13px;
  margin-top: 1px;
`;

const StyledMenu = styled(Menu)`
  ul {
    padding-top: 10px;
    padding-bottom: 10px;
  }
`;

const StyledMenuItem = styled(MenuItem)`
  padding-right: 30px;
`;

const StyledTextField = styled(TextField)`
  flex: 1;
  input {
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    color: ${(props) => (props.isTextNewRole ? props.theme.palette.grey.main : 'inherit')};
  }
  .MuiOutlinedInput-notchedOutline {
    border-color: transparent;
    outline: none;
  }
  .MuiOutlinedInput-input {
    padding: 0.75rem 1rem;
  }

  &:hover {
    .MuiOutlinedInput-notchedOutline {
      border-color: #eaeaea;
    }
  }
`;

export default RoleHeaderCell;
